//#region import libraries
import React, { useState, useEffect } from 'react';
import { useTable } from 'react-table';

// custom components
import { EditBooking } from "_organisms";

// images & icons
import { BsChevronRight } from "react-icons/bs";

// bootstrap
import Row from 'react-bootstrap/Row';

// redux
import { useSelector, useDispatch, } from 'react-redux';
import { selectUserDb } from '_redux/slices/main-screen/user';
import { selectSelectedRequests, setSelectedRequests, selectRequestsStatus, selectEditBookingStatus, setEditBooking, setEditBookingStatus, selectSkipObj } from '_redux/slices/assistance-bookings/booking-requests-table'
import { resetPostedBooking } from '_redux/slices/prm-bookings/bookings';
import { setBookingForm, reset as resetForm } from '_redux/slices/assistance-bookings/booking-form';

// styles 
import { Colors } from '_styles';
//#endregion

function translateType(type, confirmedType, userDb) {
    if (userDb?.details?.type == 'AIRLINE' && type == 'requests') {
        return {
            "requests": "airlineRequests",
            "confirmed": "airlineConfirmedRequests"
        }[type]
    }
    if (type != "confirmed") {
        return {
            "departures": "pendingDepartures",
            "arrivals": "pendingArrivals"
        }[type]
    }
    else {
        return {
            "departures": "confirmedDepartures",
            "arrivals": "confirmedArrivals"
        }[confirmedType]
    }
}

const TableEntry = (props) => {

    let row = props.row
    let i = props.i

    const dispatch = useDispatch()

    const [highlight, setHighlight] = useState(false)
    const [index, setIndex] = useState(0);
    const indexList = useSelector(selectSelectedRequests);

    const mouseOver = (index) => {
        setHighlight(true)
        setIndex(index)
    }

    const mouseLeave = (index) => {
        setHighlight(false);
        setIndex(index)
    }

    const handleClick = (index) => {
        // if already exsists unclick
        if (indexList.includes(index)) {
            // already clicked remove
            const newList = indexList.filter((item) => {
                return item !== index
            })
            dispatch(setSelectedRequests(newList))
        }
        else {
            // set click
            const newList = [...indexList, index]
            dispatch(setSelectedRequests(newList))
        }
    }

    const handleEdit = (index) => {
        dispatch(setBookingForm(props.data[index].doc))
        dispatch(setEditBooking(props.data[index].doc))
        dispatch(setEditBookingStatus(true));
    }

    return (
        <tr
            {...row.getRowProps()}
            style={{
                backgroundColor: (highlight && index == i) || (indexList != undefined && indexList != null && indexList.includes(i)) ? '#F2F2F2' : null,
                borderBottomWidth: (highlight && index == i) || (indexList != undefined && indexList != null && indexList.includes(i)) ? 1 : '1px',
                borderBottomColor: (highlight && index == i) || (indexList != undefined && indexList != null && indexList.includes(i)) ? Colors.PRM_LIGHT_BLUE : '#D8D8D8',
                borderBottomStyle: 'solid',
                height: 50,
                fontSize: 12,
                cursor: 'pointer',
                borderWidth: (highlight && index == i) || (indexList != undefined && indexList != null && indexList.includes(i)) ? 1 : 0,
                borderColor: (highlight && index == i) || (indexList != undefined && indexList != null && indexList.includes(i)) ? Colors.PRM_LIGHT_BLUE : null,
                borderRadius: 5
            }}
            onMouseOver={() => { mouseOver(i) }}
            onMouseLeave={() => { mouseLeave(i) }}
            onClick={() => { handleClick(i) }}
        >
            {row.cells.map(cell => {
                return <td style={{ padding: 12 }} {...cell.getCellProps()}>{cell.render("Cell")}</td>;
            })}
            {
                <td
                    onClick={() => { handleEdit(i) }}
                    style={{
                        textDecoration: (highlight && index == i) ? 'underline' : null
                    }}
                >
                    <div>
                        <BsChevronRight size={18} color={highlight && index == i ? Colors.PRM_LIGHT_BLUE : 'grey'} />
                    </div>
                </td>
            }
        </tr>
    )
}

const BookingRequestsTable = (props) => {

    // redux 
    const dispatch = useDispatch();
    const editBookingStatus = useSelector(selectEditBookingStatus)        // bool shows edit booking form

    const userDb = useSelector(selectUserDb)

    useEffect(() => {
        dispatch(resetPostedBooking())
        dispatch(resetForm())
    }, []);

    const skipObj = useSelector(selectSkipObj)
    const skip = skipObj[translateType(props.type, props.confirmedType, userDb)]

    const dataToDisplay = props.data.slice(skip, skip + 50)
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns: props.columns, data: dataToDisplay });

    const dataStatus = useSelector(selectRequestsStatus)

    return (
        <>
            <div>
                {
                    !editBookingStatus ?
                        (
                            (props.data.length > 0) ?
                                <table {...getTableProps()} style={{ width: '100%' }} className="mt-2">

                                    {/* column headers */}
                                    <thead style={{
                                        borderTopWidth: '1px',
                                        borderTopColor: '#D8D8D8'
                                    }}>
                                        {headerGroups.map(headerGroup => (
                                            <tr {...headerGroup.getHeaderGroupProps()}>
                                                {headerGroup.headers.map(column => (
                                                    <th
                                                        style={{
                                                            borderBottomWidth: '1px',
                                                            borderBottomColor: '#D8D8D8',
                                                            borderBottomStyle: 'solid'
                                                        }}
                                                        {...column.getHeaderProps()}
                                                    >
                                                        <div style={{ marginTop: 14 }}>
                                                            {column.render("Header")}
                                                        </div>
                                                    </th>
                                                ))}
                                            </tr>
                                        ))}
                                    </thead>

                                    <tbody {...getTableBodyProps()}>
                                        {
                                            dataStatus == 'loading' ?
                                                null
                                                :
                                                rows.map((row, i) => {
                                                    prepareRow(row);
                                                    return <TableEntry row={row} data={props.data} i={i} />
                                                })
                                        }
                                    </tbody>

                                </table>
                                :
                                (
                                    <Row style={{ opacity: 0.9 }} className="d-flex justify-content-center mt-5">
                                        <p className='mt-3' style={{ textAlign: 'center', color: Colors.PRM_LIGHT_BLUE }}>{'No Booking Requests Found.'}</p>
                                    </Row>
                                )
                        )
                        :
                        <EditBooking />
                }
            </div>
        </>
    );
}

export default BookingRequestsTable;
